import { createBrowserRouter } from 'react-router-dom';
import App from '../App';

/**
 * React Router config — DDS Mobile App
 * Fiecare route mapează la un feature screen.
 * Lazy loading pentru reducerea bundle-ului inițial.
 * IMPORTANT: Nu adăuga rute duplicate — cauzează ambiguitate la matching.
 */

const router = createBrowserRouter([
  {
    path: '/login',
    lazy: () => import('../features/auth/LoginScreen'),
  },
  {
    path: '/',
    element: <App />,
    // errorElement afișat dacă un lazy import eșuează (eroare rețea etc.)
    errorElement: (
      <div style={{ padding: '32px', textAlign: 'center', fontFamily: 'Inter, sans-serif' }}>
        <h2 style={{ fontSize: '20px', marginBottom: '12px' }}>A apărut o eroare</h2>
        <p style={{ color: '#6b7280', marginBottom: '24px' }}>
          Pagina nu a putut fi încărcată. Verifică conexiunea la internet și încearcă din nou.
        </p>
        <button
          onClick={() => window.location.href = '/'}
          style={{ padding: '12px 24px', background: '#0b6e5f', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '16px', cursor: 'pointer' }}
        >
          Înapoi la Acasă
        </button>
      </div>
    ),
    children: [
      {
        index: true,
        lazy: () => import('../features/home/HomeScreen'),
      },
      {
        path: 'produse',
        lazy: () => import('../features/products/CatalogScreen'),
      },
      {
        // Ruta canonică pentru detalii produs — format: /produs/:handle
        path: 'produs/:handle',
        lazy: () => import('../features/products/ProductDetailScreen'),
      },
      {
        path: 'cos',
        lazy: () => import('../features/cart/CartScreen'),
      },
      {
        path: 'checkout',
        lazy: () => import('../features/checkout/CheckoutScreen'),
      },
      {
        path: 'comenzi',
        lazy: () => import('../features/orders/OrdersScreen'),
      },
      {
        path: 'comanda/:id',
        lazy: () => import('../features/orders/OrderDetailScreen'),
      },
      {
        path: 'favorite',
        lazy: () => import('../features/favorites/FavoritesScreen'),
      },
      {
        path: 'cont',
        lazy: () => import('../features/account/AccountScreen'),
      },
      {
        path: 'setari',
        lazy: () => import('../features/settings/SettingsScreen'),
      },
      {
        path: 'politici/:slug',
        lazy: () => import('../features/policies/PolicyDetail'),
      },
      {
        path: 'cauta',
        lazy: () => import('../features/products/SearchScreen'),
      },
      {
        // Ruta 404 — catch-all pentru orice path necunoscut
        path: '*',
        lazy: async () => ({
          Component: () => (
            <div style={{ padding: '32px', textAlign: 'center', fontFamily: 'Inter, sans-serif' }}>
              <h2 style={{ fontSize: '20px', marginBottom: '12px' }}>Pagina nu există</h2>
              <p style={{ color: '#6b7280', marginBottom: '24px' }}>
                Link-ul accesat nu este valid.
              </p>
              <a href="/" style={{ color: '#0b6e5f', fontWeight: 600 }}>Înapoi la Acasă</a>
            </div>
          ),
        }),
      },
    ],
  },
]);

export default router;
